import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { Box, Divider, Typography } from "@mui/material";

import { InfoButton } from "./Tooltips";

/**
 * The section break used by the configuration dialogs: a rule, then the title
 * of what follows. Extracted from `FormBuilder` so screens outside the
 * generated forms cut their sections the same way.
 */
const SectionSeparator = ({
  label,
  subLabel,
  subLabelValues,
  tooltip,
  align = "center",
}: {
  /** Empty for a bare rule, when the fields below need no title. */
  label?: string;
  subLabel?: string;
  /** Counts and dates the sub-label names, when it is not a fixed sentence. */
  subLabelValues?: Record<string, ReactNode>;
  tooltip?: string;
  /** Left for screens whose fields are left-aligned, so the two line up. */
  align?: "left" | "center";
}) => (
  <>
    <Divider
      sx={{
        borderColor: "divider",
        width: align === "center" ? "60%" : "100%",
        mt: 1,
        mx: align === "center" ? "auto" : 0,
        mb: 1,
      }}
    />
    {label && (
      <Box sx={{ textAlign: align, mb: 1.5, color: "text.secondary" }}>
        <FormattedMessage id={label} />
        {tooltip && <InfoButton title={tooltip} sxStyles={{ marginLeft: 1 }} />}
        {subLabel && (
          <Typography
            sx={{
              fontSize: "0.8rem",
              fontStyle: "italic",
              marginTop: "1%",
            }}
          >
            <FormattedMessage id={subLabel} values={subLabelValues} />
          </Typography>
        )}
      </Box>
    )}
  </>
);

export default SectionSeparator;
